import React from 'react';
import { useBookingData } from '../context/BookingContext';

const Client = () => {

    const { booking } = useBookingData();

    const client = booking?.clientCompany || '';
    const bookingContactName = booking?.contactName || '';
    const bookingContactNumber = booking?.contactNumber || '';
    const bookingContactEmail = booking?.contactEmail || '';
    const bookingAddress = (booking?.address || '').split(',');
    const bookingDeliveryAddress = (booking?.deliveryAddress || '').split(',');

    return (
        <div className="w-full pt-8 sm:pt-16">
            <div className="rounded-md w-11/12 sm:w-10/12 shadow-md min-h-60 mx-auto p-4 sm:p-6">
                <div className="mb-1 font-medium text-sm sm:text-base">
                    {client}
                </div>
                <div className="text-xs text-gray-500">
                    <div>
                        {bookingContactName}
                    </div>
                    <div>
                        {bookingContactNumber}
                    </div>
                    <div className="break-all">
                        {bookingContactEmail}
                    </div>
                </div>
                <div className="border-b border-gray-400 mb-4 pb-2"></div>
                <div className="flex flex-col sm:flex-row mx-auto gap-4 sm:gap-0">
                    <div className="w-full sm:w-1/2 text-sm">
                        <span className="font-medium">Billing Address</span>
                        <div className="text-xs text-gray-500 mt-1">
                            {bookingAddress.map((addressLine, i) => (
                                <div key={i}>
                                    {addressLine}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="w-full sm:w-1/2 text-sm">
                        <span className="font-medium">Delivery Address</span>
                        <div className="text-xs text-gray-500 mt-1">
                            {bookingDeliveryAddress.map((addressLine, i) => (
                                <div key={i}>
                                {addressLine}
                                </div>
                            )) }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Client;
